<script setup lang="ts">
import type { DetectionModel } from '@/types/models/DetectionModel'
import { TypographyItem } from '@rfc/rfc-components-library'
import { EColors } from '@rfc/rfc-components-library/types'

type Props = DetectionModel
defineProps<Props>()
</script>

<template>
    <TypographyItem :label="bib" :color="withdrawal ? EColors.DANGER : undefined" />
</template>
